import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-detail-mark-auto',
  templateUrl: './detail-mark-auto.component.html',
  styleUrls: ['./detail-mark-auto.component.scss']
})
export class DetailMarkAutoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
